/* ==========================================================================
   TOL — Google click ID capture, site-wide (developer brief 6)

   Captures the click identifier on the FIRST page of the session and keeps
   it for 90 days, so a visitor who lands on a product page and submits a
   form three pages later still carries it. Without it a lead can never be
   attributed to the ad that produced it, and quote-to-sale revenue never
   reaches Google Ads.

   What changed from the original version:
     - also captures wbraid and gbraid, which Google Ads sends instead of
       gclid for some iOS and in-app traffic
     - records the landing page URL and a per-form identifier, so sports
       fencing and balustrade leads can be told apart on arrival
     - populates every LEAD form automatically instead of four hardcoded
       selectors, so a new form is covered without another code change

   Deliberately NOT changed: the balustrade quote form's existing field
   names and the tol_gclid cookie. That form works, and is still populated
   by exactly the same names and selectors as before.

   Newsletter signups never receive a click ID. Shopify renders newsletter
   forms as form_type=customer and lead forms as form_type=contact, which is
   what the split below keys on.
   ========================================================================== */
(function () {
  var DAYS = 90;

  function setCookie(name, value, days) {
    if (!value) return; // never overwrite a stored value with an empty one
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : '';
  }

  function getParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  /* ---- 1. capture on landing ------------------------------------------
     Only write when the parameter is actually present, so a later organic
     pageview cannot wipe the value from the original paid click. */
  var gclid = getParam('gclid');
  var wbraid = getParam('wbraid');
  var gbraid = getParam('gbraid');

  if (gclid) setCookie('tol_gclid', gclid, DAYS);
  if (wbraid) setCookie('tol_wbraid', wbraid, DAYS);
  if (gbraid) setCookie('tol_gbraid', gbraid, DAYS);

  /* Landing page = the first page of this visit, written once. */
  if (!getCookie('tol_landing_page')) {
    setCookie('tol_landing_page', window.location.href.slice(0, 500), DAYS);
  }

  var stored = {
    gclid: getCookie('tol_gclid'),
    wbraid: getCookie('tol_wbraid'),
    gbraid: getCookie('tol_gbraid'),
    landing: getCookie('tol_landing_page'),
  };

  /* ---- 2. name the form ------------------------------------------------
     Without an identifier, sports fencing and balustrade leads arrive in one
     undifferentiated pile and cannot be attributed separately. Prefer an
     explicit data-tol-form attribute, then a nearby heading, then the path. */
  function formIdentifier(form) {
    var explicit = form.getAttribute('data-tol-form');
    if (explicit) return explicit;

    var section = form.closest('.shopify-section, section, [id^="shopify-section"]');
    var heading = section && section.querySelector('h1, h2, h3');
    var label = heading ? heading.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) : '';

    return (label ? label + ' — ' : '') + window.location.pathname;
  }

  /* ---- 3. populate ----------------------------------------------------- */
  /* preserveExisting: leave a value the theme already set. contact[Form] is
     used by the ask-an-expert and notify-me forms to carry their own label,
     and overwriting it would destroy information the theme is relying on. */
  function ensureHidden(form, name, value, preserveExisting) {
    if (!value) return;
    var field = form.querySelector('input[name="' + name + '"]');
    if (field && preserveExisting && String(field.value).trim() !== '') return;
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
    field.setAttribute('value', value);
  }

  function isLeadForm(form) {
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact') return false; // customer = newsletter / account
    // belt and braces: a contact form explicitly tagged newsletter is not a lead
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (tags && /newsletter/i.test(tags.value)) return false;
    return true;
  }

  function populate() {
    /* (a) original behaviour, unchanged — the balustrade quote form and
       anything else already using these names keeps working as before. */
    if (stored.gclid) {
      ["input[name='Reference']", "input[name='GCLID']", "input[name='Source']", '#gclid-field'].forEach(function (
        sel
      ) {
        var f = document.querySelector(sel);
        if (f) {
          f.value = stored.gclid;
          f.setAttribute('value', stored.gclid);
          f.dispatchEvent(new Event('input', { bubbles: true }));
          f.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* (b) every lead form on the page, whether or not it existed when this
       was written. Newsletter signups are excluded by isLeadForm. */
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
      if (!isLeadForm(form)) return;
      ensureHidden(form, 'contact[GCLID]', stored.gclid);
      ensureHidden(form, 'contact[WBRAID]', stored.wbraid);
      ensureHidden(form, 'contact[GBRAID]', stored.gbraid);
      ensureHidden(form, 'contact[Landing page]', stored.landing);
      // preserve the theme's own label where it sets one (ask an expert, notify me)
      ensureHidden(form, 'contact[Form]', formIdentifier(form), true);
    });

    /* (c) the HulkApps form builder, which is where the balustrade quote form
       actually lives. It renders in a CROSS-ORIGIN iframe, so nothing above
       can reach inside it — the four legacy selectors this file used to
       target do not exist on the page at all.

       The app receives context only through the referrer_url it is loaded
       with, and that carries the click ID only when it happens to be in the
       address bar. So it works for someone who lands straight on the quote
       page from an ad, and silently fails for someone who lands on a product
       page and reaches the form three pages later — which is the journey the
       brief actually describes.

       Re-point the iframe once, with the stored values appended, so the app
       receives them however the visitor arrived. */
    patchHulkFrames();
  }

  var patchedFrames = [];
  function patchHulkFrames() {
    if (!stored.gclid && !stored.wbraid && !stored.gbraid) return;

    Array.prototype.forEach.call(
      document.querySelectorAll('.pxFormGenerator iframe, iframe[src*="formbuilder.hulkapps.com"]'),
      function (frame) {
        var src = frame.getAttribute('src') || '';
        if (!src || patchedFrames.indexOf(frame) !== -1) return;

        var extra = '';
        if (stored.gclid && src.indexOf('gclid') === -1) extra += '&gclid=' + encodeURIComponent(stored.gclid);
        if (stored.wbraid && src.indexOf('wbraid') === -1) extra += '&wbraid=' + encodeURIComponent(stored.wbraid);
        if (stored.gbraid && src.indexOf('gbraid') === -1) extra += '&gbraid=' + encodeURIComponent(stored.gbraid);
        if (!extra) {
          patchedFrames.push(frame); // already carries everything we have
          return;
        }

        patchedFrames.push(frame); // mark first, so the reload cannot loop
        frame.setAttribute('src', src + extra);
      }
    );
  }

  function init() {
    populate();

    /* Forms open in drawers and popups after load, so keep checking briefly
       and watch for anything injected later. */
    var tries = 0;
    var timer = setInterval(function () {
      populate();
      if (++tries >= 20) clearInterval(timer);
    }, 500);

    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) {
            populate();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
